import BaseDropifyForm from './BaseDropifyForm';

export default class InvoiceForm extends BaseDropifyForm {

    constructor() {
        super('#invoice_invoice');
    }
}